export default "__VITE_ASSET__Xka7_CVD__"